import React, { useState, useEffect, useRef } from 'react';
import { GripVertical, Download, History, SlidersHorizontal, Trash2, RefreshCw, Flame } from 'lucide-react';

const ActionMenu = ({ disabled, onRefresh, onDownload, onModifyView, showModifyView = false, onBulkDelete, showBulkDelete = false, onChangeHistory, showChangeHistory = false, onPurge, showPurge = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleClick = () => {
    if (!disabled) {
      setIsOpen(!isOpen);
    }
  };

  const handleRefresh = () => {
    setIsOpen(false);
    onRefresh?.();
  };

  const handleDownload = () => {
    setIsOpen(false);
    onDownload?.();
  };

  const handleModifyView = () => {
    setIsOpen(false);
    onModifyView?.();
  };

  const handleBulkDelete = () => {
    setIsOpen(false);
    onBulkDelete?.();
  };

  return (
    <div className="action-menu" ref={menuRef}>
      <button
        className={`action-menu-btn ${disabled ? 'disabled' : ''}`}
        onClick={handleClick}
        disabled={disabled}
        title={disabled ? 'No actions available' : 'Actions'}
      >
        <GripVertical size={16} />
      </button>
      {isOpen && !disabled && (
        <div className="action-menu-dropdown">
          {!!onRefresh && (
            <button className="action-menu-item" onClick={handleRefresh}>
              <RefreshCw size={16} />
              <span>Refresh</span>
            </button>
          )}
          {showModifyView && (
            <button className="action-menu-item" onClick={handleModifyView}>
              <SlidersHorizontal size={16} />
              <span>Modify View</span>
            </button>
          )}
          {!!onDownload && (
            <button className="action-menu-item" onClick={handleDownload}>
              <Download size={16} />
              <span>Download</span>
            </button>
          )}
          {showBulkDelete && (
            <button className="action-menu-item action-menu-item-danger" onClick={handleBulkDelete}>
              <Trash2 size={16} />
              <span>Bulk Delete</span>
            </button>
          )}
          {showChangeHistory && (
            <button className="action-menu-item" onClick={() => { setIsOpen(false); onChangeHistory?.(); }}>
              <History size={16} />
              <span>Audit Trail</span>
            </button>
          )}
          {showPurge && (
            <button className="action-menu-item action-menu-item-danger" onClick={() => { setIsOpen(false); onPurge?.(); }}>
              <Flame size={16} />
              <span>Purge Old Records</span>
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default ActionMenu;
